import { useState } from 'react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';
import { NeobrutalButton } from '@/components/marketing/v2/NeobrutalButton';

const FAQ: ReadonlyArray<{ q: string; a: string }> = [
  {
    q: 'Quels moyens de paiement acceptez-vous ?',
    a: 'Orange Money, MTN MoMo, Wave pour le Mobile Money. Virement bancaire XOF/XAF et carte internationale pour les plans annuels. Les paiements se font directement dans ton compte, sans redirection.',
  },
  {
    q: 'Puis-je changer de plan à tout moment ?',
    a: 'Oui. Le passage à un plan supérieur est immédiat, la différence est calculée au prorata de la période restante.',
  },
  {
    q: 'Le mode hors ligne est-il disponible sur tous les plans ?',
    a: "Oui, c'est au cœur de Velko. Même sur le plan Gratuit, la caisse continue à fonctionner à 100% sans réseau.",
  },
  {
    q: "Y a-t-il une période d'essai gratuite ?",
    a: 'Oui, 14 jours sur les plans Starter, Croissance et Pro, sans carte bancaire. Tu peux aussi rester sur le plan Gratuit aussi longtemps que tu veux.',
  },
  {
    q: 'Mes données sont-elles en sécurité ?',
    a: 'Chiffrement AES-256 au repos (SQLCipher en local, PostgreSQL chiffré côté serveur), TLS pour tout le transit. Sauvegardes quotidiennes, conformité RGPD et DPA disponible pour les plans Pro et Business.',
  },
  {
    q: 'Proposez-vous une formation pour mes équipes ?',
    a: 'Oui. Vidéos gratuites pour Starter et Croissance, sessions en visio pour Pro, formation sur site incluse pour Business. Le plan Gratuit a accès à la base de connaissance publique.',
  },
];

export default function PricingFaqV2() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-charcoal-950 py-24 text-white md:py-32">
      <div className="mx-auto max-w-4xl px-6 md:px-8">
        <div className="text-center">
          <SectionLabel tone="dark" className="justify-center">
            Questions fréquentes
          </SectionLabel>
          <h2 className="mt-6 font-marketing-display text-[clamp(32px,4.2vw,54px)] font-bold leading-[1] tracking-[-0.035em]">
            Tout ce que tu veux <span className="text-lime-400">savoir avant</span>.
          </h2>
        </div>

        <ul className="mt-14 space-y-4">
          {FAQ.map((item, idx) => {
            const isOpen = open === idx;
            return (
              <li
                key={item.q}
                className="border-2 border-charcoal-700 bg-charcoal-800 shadow-neobrutal-lime-6"
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? null : idx)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-marketing-display text-[17px] font-bold text-white md:text-lg cursor-pointer"
                >
                  <span>{item.q}</span>
                  <span
                    className={`flex h-8 w-8 flex-shrink-0 items-center justify-center border-2 border-charcoal-800 transition-colors ${isOpen ? 'bg-lime-500 text-charcoal-800' : 'bg-charcoal-700 text-lime-400'}`}
                    aria-hidden="true"
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.6"
                      className={`transition-transform ${isOpen ? 'rotate-45' : ''}`}
                    >
                      <path d="M7 2v10" />
                      <path d="M2 7h10" />
                    </svg>
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t-2 border-charcoal-700 bg-charcoal-800 px-6 py-5 font-marketing-body text-[15px] leading-relaxed text-charcoal-200 md:text-base">
                    {item.a}
                  </div>
                )}
              </li>
            );
          })}
        </ul>

        <div className="mt-12 text-center">
          <p className="mb-5 font-marketing-body text-[15px] text-charcoal-200">
            Une autre question ? On répond en moins de 24 h.
          </p>
          <NeobrutalButton as="link" to="/contact" variant="primary" size="md">
            Contacter l'équipe
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            >
              <path d="M5 12h14" />
              <path d="M13 6l6 6-6 6" />
            </svg>
          </NeobrutalButton>
        </div>
      </div>
    </section>
  );
}
